<div mat-dialog-title>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
        <h1 class="titulo-simpli">Documentos de Terceros</h1>
        <small class="subtitulo-simpli">Vista previa</small>
    </div>
</div>




<div mat-dialog-content>

    <div class="row animate__animated animate__fadeIn" *ngIf="loading == true">

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="sinRegistros" style="text-align: center;">
                <small class="small-sinregistros" style="font-size: 15px;margin-top: 20px;">
                    <div style="text-align: center;">
                        <i style="font-size: 30px;color:gray;margin-bottom: 20px;"
                            class="fa-solid fa-circle-notch fa-spin-pulse"></i>
                    </div>
                </small>
            </div>
        </div>

    </div>


    <div class="file-container" *ngIf="!loading"> <!--*ngIf="showSpinner"-->

        <div class="sinRegistros animate__animated animate__fadeIn" style="text-align: center;" *ngIf="!has_file">
            <small class="small-sinregistros">
                <div style="text-align: center;"><span style="font-size: 30px;" class="material-icons">info</span></div>
                No hay Archivos cargados
            </small>
        </div>

        <div *ngFor="let file of archivos" class="row file-detail"
            style="margin-bottom:7px; position: relative; width: 100%; background: #f5f5f5; border-radius: 8px; display: inline-block;">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top responfile">
                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 respon-left">
                    <a href="{{ file.ruta }}" target="_blank" style="cursor:pointer; height:25px;">
                        <i class="material-icons" style="font-size: 25px; color: #484848;">
                            folder
                        </i>
                    </a>

                </div>
                <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11 respon-right">
                    <span class="right-span">
                        <small class="textocajas" matTooltip="{{file.file}}">
                            <span style="font-weight: 400;">
                                {{file.file | slice:0:30}}

                            </span>
                        </small>
                        <br>
                        <small class="textocajas">
                            <span style="font-weight: 400; font-size: 11px; text-align: left;">
                                {{file.date_created }}
                            </span>
                        </small>

                    </span>
                    <div class="space-between">
                        <a (click)="descargarArchivo(file)" matTooltip="Descargar" class="boton-descargar download"
                            style="cursor:pointer;">
                            <mat-icon>download</mat-icon>
                        </a>

                        <span matTooltip="{{file.descripcion_asistente}}"
                            [ngStyle]="{ 'color': file.checkeo_asistente ? 'var(--simpli-color7)' : 'var(--simpli-color8)' }">
                            <mat-icon>smart_toy</mat-icon>
                        </span>
                        <mat-icon *ngIf="file.visto" matTooltip="Archivo revisado"
                            style="color:#4AD991; text-align:center;">
                            visibility
                        </mat-icon>
                        <mat-icon *ngIf="!file.visto" matTooltip="No has revisado este archivo"
                            style="color:#C5221F; text-align:center;">
                            visibility_off
                        </mat-icon>

                    </div>

                </div>


            </div>
        </div>

        <input type="file" id="file_chooser" (change)="upload_file($event)" multiple style="display: none;" />

        <div class="add-button-container">
            <button (click)="open_chooser()" matTooltip="Agregar archivo" mat-mini-fab color="primary">
                <i class="material-icons"> add </i>
            </button>
        </div>

    </div>


</div>


<div style="margin-top: 10px;" mat-dialog-actions>
    <button class="secondary-button" mat-stroked-button color="primary" mat-dialog-close>Cerrar</button>
</div>